import { render, staticRenderFns } from "./TeamInvite.vue?vue&type=template&id=908ec620&scoped=true&"
import script from "./TeamInvite.vue?vue&type=script&lang=js&"
export * from "./TeamInvite.vue?vue&type=script&lang=js&"
import style0 from "./TeamInvite.vue?vue&type=style&index=0&id=908ec620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908ec620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('908ec620')) {
      api.createRecord('908ec620', component.options)
    } else {
      api.reload('908ec620', component.options)
    }
    module.hot.accept("./TeamInvite.vue?vue&type=template&id=908ec620&scoped=true&", function () {
      api.rerender('908ec620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Pages/TeamInvite.vue"
export default component.exports